import { IAccountChangeStatus, IChangeResult, LeadStatus } from 'fitbeat.models';
import { IMappedPlan, PaymentService } from 'fitbeat.payment-service';
import { UserProfile } from '../../entities/user/userprofile';
import { UserProfileService } from '../user';
import { IChangeFunction } from './accountstatusmanager';

export class NoActiveSubscriptionToFamilyPlan implements IChangeFunction {
  public async validate(): Promise<IAccountChangeStatus> {
    return {
      fromStatus: 'NoActiveSubscription',
      toStatus: 'FamilySubscription',
      success: true,
      message: '',
    };
  }

  public async change(
    userProfile: UserProfile,
    currentPlan: IMappedPlan,
    paymentService: PaymentService,
    userProfileService: UserProfileService,
    familyPlanOwnerUserProfileId?: string,
  ): Promise<IChangeResult> {
    userProfile.planOwnerUserProfileId = familyPlanOwnerUserProfileId;
    userProfile.leadStatus = LeadStatus.Won;
    await userProfileService.updateUserProfile(userProfile.uid, userProfile);

    return {
      marketingAnalyticsData: {
        trackingEventName: 'subscription_to_family',
      },
    };
  }
}
